import { StoreState } from '@/redux/types';
import { getConfigurationErrors } from './getConfigurationErrors';
import { getConfigurationIds } from './getConfigurationIds';

export function hasCopyrightErrors(state: StoreState) {
  for (const configurationId of getConfigurationIds(state)) {
    const configurationErrors = getConfigurationErrors(state, configurationId);
    if (configurationErrors && Boolean(configurationErrors.copyright)) {
      return true;
    }
  }

  return false;
}
